
import { toRefs, reactive, computed } from 'vue'
import Account from '@/views/login/component/account.vue'
import { useStore } from '@/store/index.ts'
export default {
  name: 'login',
  components: { Account },
  setup () {
    const store = useStore()
    const state = reactive({
      tabsActiveName: 'account',
      isTabPaneShow: true,
      isScan: false
    })
    // 获取布局配置信息
    const getThemeConfig = computed(() => {
      return store.state.themeConfig.themeConfig
    })
    // 切换密码、手机登录
    const onTabsClick = () => {
      state.isTabPaneShow = !state.isTabPaneShow
    }
    return {
      onTabsClick,
      getThemeConfig,
      ...toRefs(state)
    }
  }
}
